function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.1677 9.5L17.8616 1.80608C17.9476 1.72061 18 1.60256 18 1.47222C18 1.21156 17.7889 1 17.5278 1C17.3979 1 17.2799 1.05289 17.1939 1.13836L9.5 8.83228L1.80608 1.13836C1.72061 1.05289 1.60256 1 1.47222 1C1.21108 1 1 1.21156 1 1.47222C1 1.60256 1.05242 1.72061 1.13836 1.80656L8.83228 9.5L1.13836 17.1939C1.05242 17.2794 1 17.3974 1 17.5278C1 17.7889 1.21108 18 1.47222 18C1.60256 18 1.72061 17.9471 1.80608 17.8616L9.5 10.1677L17.1939 17.8616C17.2799 17.9471 17.3979 18 17.5278 18C17.7889 18 18 17.7889 18 17.5278C18 17.3974 17.9476 17.2794 17.8616 17.1939L10.1677 9.5Z",
  fill: "#EBEBEB",
  stroke: "#9FAFB9"
});

var SvgCloseSimple = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseSimple, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-simple.43eb9194.svg";
export { ForwardRef as ReactComponent };